import React from "react";

const PorQueVotar = () => {
  return (
    <section className=" py-10 px-4">
      <div className="mx-auto text-center">
        {/* Título */}
        <h2 className="text-xl sm:text-xl font-bold mb-2">POR QUE VOTAR?</h2>

        {/* Linha amarela */}
        <div className="w-24 h-1 bg-[#f6b100] mx-auto mb-6" />

        {/* Texto */}
        <div className="text-justify text-sm sm:text-base text-gray-700 space-y-3">
          <p>
            Seu voto na eleição para Delegados Seccionais da COOPERFORTE é mais do que um ato eleitoral, é a
            oportunidade de escolher quem vai representar os interesses dos cooperados.
          </p>
          <p>
            O Delegado é um dos principais responsáveis por garantir que as decisões da COOPERFORTE estejam sempre
            alinhadas com as necessidades dos cooperados. Ao votar, você garante que a sua voz seja ouvida e que a
            cooperativa continue a crescer de forma sustentável para todos.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PorQueVotar;
